// extracted by mini-css-extract-plugin
export default {"circleWrapper":"fHcz8","statusCircle":"yugP7","handle":"IGgDC","large":"rZ6Ah","small":"cwBAY","green":"K8mD4","orange":"MS_Ve","gray":"KxoI2","white":"xdSSp"};